module.exports = __webpack_public_path__ + "static/media/Icon_NewAccount.73d2ff90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_NewAccount.svg
// module id = 2304
// module chunks = 0